import { PublishRulesRenderFunc } from '../types/PublishRulesRenderFunc';
import { getPublishDeadlineOptions } from './getPublishDeadlineOptions';

export const renderDeadline: PublishRulesRenderFunc = item => {
  const { newValue, oldValue } = item;

  const deadlineOptions = getPublishDeadlineOptions() || [];

  const renderedOldOption = deadlineOptions.find(option => option.value === oldValue);
  const renderedNewOption = deadlineOptions.find(option => option.value === newValue);

  return {
    renderedOldValue: renderedOldOption?.label || '',
    renderedNewValue: renderedNewOption?.label || '',
  };
};
